import type { IconData } from '@stacksjs/iconify-core'

export const hourglass: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 2v4a3 3 0 1 0 6 0V2zm8 16a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2v-4a4.99 4.99 0 0 1 2-4a5 5 0 0 1-2-4V2a1 1 0 1 1 0-2h10a1 1 0 0 1 0 2v4a5 5 0 0 1-2 4a4.99 4.99 0 0 1 2 4zm-2 0v-4a3 3 0 0 0-6 0v4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default hourglass
